import { useEffect } from "react";

import type { Status, StatusController } from "./useStatusController";

type Options = {
  statusController: StatusController;
  status?: Status | Status[];
  listener: (status: Status) => void;
};

export const useStatusListener = (options: Options) => {
  useEffect(() => {
    const { statusController, status, listener } = options;
    const cleanup = statusController.registerListener(listener, status);
    return cleanup;
  }, [options.status]);
};
